<template>

<div class="main list-view">

	<div class="sub-header">
		<div class="input-with-control">
			<input type="search" ref="search_term" v-model="filters.search_term" placeholder="Search..." @search="getList()" v-focus>
			<div class="button action input-go" @click="getList()"><i class="fas fa-search"></i></div>
		</div>
		<div class="controls">
			<pagination :paging="paging" @updatePage="goToPage"></pagination>
		</div>
	</div>

	<div class="filters">
		<label>For Client</label>
		<select v-model="filters.client_id" @change="toggleFilter('client_id')">
			<option value="">Select...</option>
			<option v-for="(client, index) in clients" :value="client.client_id">{{ client.company_name }} [{{ client.client_id}}]</option>
		</select>
		<ul class="checkbox-group">
			<li>
				<span :class="['pointer', 'far', filters.client_is_demo ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('client_is_demo')"></span>
				<label>Client Is Demo</label>
			</li>
			<li>
				<span :class="['pointer', 'far', filters.domain_is_demo ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('domain_is_demo')"></span>
				<label>Domain Is Demo</label>
			</li>
			<li>
				<span :class="['pointer', 'far', filters.hide_website ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('hide_website')"></span>
				<label>Hide Website</label>
			</li>
			<li>
				<span :class="['pointer', 'far', filters.inactive ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('inactive')"></span>
				<label>Include Inactive</label>
			</li>
		</ul>

		<div class="divider"></div>
		<div v-if="!showDetail">
			<div class="button neutral" @click="clearFilters()">Clear Filters</div>
			<div class="button action" @click="newItem()">New Domain</div>
			<div class="divider"></div>
			<div class="extra-menu-item" @click="getList()">Reload List</div>
			<router-link v-if="legacyLink" :to="legacyLink" class="extra-menu-item">Legacy Version</router-link>
		</div>
		<div v-else>
			<div :class="['button', saving ? 'disabled' : 'action']" @click="saveItem()">Save Domain</div>
			<div class="divider"></div>
			<button class="button neutral" @click="backToList()">Back To List</button>
		</div>
	</div>

	<div v-if="!showDetail" class="list">

		<div v-if="list.length == 0" class="empty-list">
			This list is empty
		</div>

		<table v-else class="data-list" cellpadding="0" cellspacing="0">
			<thead>
				<tr>
					<th class="list">Domain Name</th>
					<th class="list">Client</th>
					<th class="list center">Endpoint</th>
					<th class="list center">Client Is Demo</th>
					<th class="list center">Domain Is Demo</th>
					<th class="list center">Hide Website</th>
					<th class="list center">Is Primary</th>
				</tr>
			</thead>
			<tr v-for="(domain, index) in list" class="clickable-list-item" @click="getItem(domain.client_domain_id)">
				<td class="list">{{ domain.domain_name }}</td>
				<td class="list">{{ domain.company_name }}</td>
				<td class="list">{{ domain.endpoint.substring(0,12) }}</td>
				<td class="list center"><i v-if="domain.client_is_demo == 1" class="fa fa-check"></i></td>
				<td class="list center"><i v-if="domain.domain_is_demo == 1" class="fa fa-check"></i></td>
				<td class="list center"><i v-if="domain.website_hidden == 1" class="fa fa-check"></i></td>
				<td class="list center"><i v-if="domain.is_primary_domain" class="fa fa-check"></i></td>
			</tr>
		</table>

	</div>

	<div v-if="showDetail" class="detail">
		<div class="two-columns">
			<div>
				<label>Client</label>
				<select v-model="detail.client_id">
					<option value="">Select...</option>
					<option v-for="(client, index) in clients" :value="client.client_id">{{ client.company_name }} [{{ client.client_id}}]</option>
				</select>
				<label>Client Type</label>
				<input type="text" v-model="detail.client_type" readonly>
				<label>Domain Name</label>
				<input type="text" v-model="detail.domain_name" />
				<label>Endpoint</label>
				<input type="text" v-model="detail.endpoint">
				<label>IP Address</label>
				<input type="text" v-model="detail.ip_address">
				<label>SSL Expires</label><br>
				<input type="date" v-model="detail.ssl_expires" style="width: 15em;">
				<div class="one-three-columns align-items-end">
					<div>
						<checkbox v-model="detail.domain_is_demo" label="Domain Is Demo" :key="'domain_is_demo+' + detail.domain_is_demo" class="v-spaced"/>
					</div>
					<div class="instruction">
						CCs will not go through on dealer's website or POS under this domain.
					</div>
					<div>
						<checkbox v-model="detail.website_hidden" label="Hide Website" :key="'website_hidden_' + detail.website_hidden" class="v-spaced"/>
					</div>
					<div class="instruction">
						Shows the "Coming Soon" page instead of dealer website.
					</div>
					<div>
						<checkbox v-model="detail.is_primary_domain" label="Primary Domain" :key="'is_primary_domain_' + detail.is_primary_domain" class="v-spaced"/>
					</div>
					<div class="instruction">
						The dealer's primary domain.
					</div>
					<div>
						<checkbox v-model="detail.domain_is_inactive" label="Domain Inactive" :key="'domain_is_inactive_' + detail.domain_is_inactive" class="v-spaced"/>
					</div>
					<div class="instruction">
						This domain will no longer go anywhere in our system.
					</div>					
				</div>
			</div>
			<div>
				<label>Notes</label>
				<textarea v-model="detail.notes"></textarea>
				<checkbox v-model="detail.credentials_failed" label="Credentails Failed" :key="'credentials_failed_' + detail.credentials_failed" class="v-spaced"/>
			</div>
		</div>
	</div>

	<message-modal v-if="message" :message="message" :loading="loading || saving" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

</div>

</template>

<script>
import Checkbox from '@/components/Checkbox'
import MessageModal from '@/components/MessageModal'
import ToolTip from '@/components/ToolTip.vue'
export default {
	name: 'client_domains',
	components: {
		'checkbox': Checkbox,
		'message': MessageModal,
		'tool-tip': ToolTip
	},
	data() {
		return {
			loading: true,
			page: 1,
			showPagination: false,
			filters: {},
			list: [],
			paging: {},
			showDetail: false,
			detail: {},
			clients: [],
			saving: false,
			message: '',
			messageStatus: '',
			messageTimeout: 0,
			legacyLink: ''
		}
	},
	created() {
		this.getClientList()
		this.clearFilters()
	},
	methods: {
		getClientList() {
			this.apiCall({ destination: 'get_list_clients_full_list' }).then(obj => {
				this.clients = obj.clients
			}).catch(err => {
				console.log(err);
			})
		},
		clearFilters() {
			this.filters = {
				page: 1,
				search_term: '',
				client_is_demo: '',
				domain_is_demo: '',
				hide_website: '',
				inactive: '',
				client_id: ''
			}
			this.getList()
		},
		toggleFilter(which) {
			if (which != 'client_id') {
				this.filters[which] = !this.filters[which]
			}
			this.filters.page = 1
			this.getList()
		},
		getList() {
			this.showDetail = false
			this.loading = true
			this.apiCall({ destination: 'get_list_client_domains', data: this.filters }).then(obj => {
				this.loading = false
				this.list = obj.list
				this.paging = obj.paging
				if (obj.legacy_link) {
					this.legacyLink = obj.legacy_link
				}
			}).catch(err => {
				console.log(err)
			})
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		getItem(clientDomainId) {
			this.loading = true
			this.apiCall({ destination: 'get_item_client_domain', data: { client_domain_id: clientDomainId } }).then(obj => {
				this.detail = obj.detail
				this.loading = false
				this.showDetail = true
			}).catch(err => {
				console.log(err)
			})
		},
		newItem() {
			this.detail = {
				client_id: '',
				domain_name: ''
			}
			this.showDetail = true
		},
		saveItem() {
			if (this.saving) { return }
			this.saving = true
			this.message = 'Saving client domain...'
			this.messageTimeout = 0
			this.apiCall({ destination: 'save_item_client_domain', data: this.detail }).then(obj => {
				this.saving = false
				this.messageStatus = obj.status
				this.message = obj.message || 'Client domain saved!'
				if (obj.status == 'success') {
					this.messageTimeout = 1000
					this.getItem(obj.client_domain_id)
				}
			}).catch(err => {
				console.log(err)
			})
		},
		backToList() {
			this.showDetail = false
			this.detail = {}
			this.getList()
		}
	}
}
</script>

<style lang="scss" scoped>
</style>
